import { addStrings } from './vulcan-lib';

addStrings('en', {
  'forms.submit': 'Submit',
  'forms.cancel': 'Cancel',
  'forms.select_option': '-- select option --',
  'forms.delete': 'Delete',
  'forms.delete_confirm': 'Delete document?',
  'forms.revert': 'Revert',
  'forms.confirm_discard': 'Discard changes?',

  'users.profile': 'Profile',
  'users.complete_profile': 'Complete your Profile',
  'users.profile_completed': 'Profile completed.',
  'users.edit_account': 'Edit Account',
  'users.edit_success': 'User “{name}” edited',
  'users.log_in': 'Log In',
  'users.sign_up': 'Sign Up',
  'users.sign_up_log_in': 'Sign Up/Log In',
  'users.log_out': 'Log Out',
  'users.bio': 'Bio',
  'users.displayName': 'Display Name',
  'users.email': 'Email',
  'users.twitterUsername': 'Twitter Username',
  'users.website': 'Website',
  'users.groups': 'Groups',
  'users.avatar': 'Avatar',
  'users.notifications': 'Notifications',
  'users.notifications_users': 'New Users Notifications',
  'users.notifications_posts': 'New Posts Notifications',
  'users.newsletter_subscribeToNewsletter': 'Subscribe to newsletter',
  'users.users_admin': 'Admin',
  'users.admin': 'Admin',
  'users.isAdmin': 'Admin',
  'users.posts': 'Posts',
  'users.upvoted_posts': 'Upvoted Posts',
  'users.please_log_in': 'Please log in',
  'users.please_sign_up_log_in': 'Please sign up or log in',
  'users.cannot_post': 'Sorry, you do not have permission to post at this time',
  'users.cannot_comment': 'Sorry, you do not have permission to comment at this time',
  'users.subscribe': 'Subscribe to this user\'s posts',
  'users.unsubscribe': 'Unsubscribe to this user\'s posts',
  'users.subscribed': `You have subscribed to this user's posts.`,
  'users.unsubscribed': `You have unsubscribed from this user's posts.`,
  'users.subscribers': 'Subscribers',
  'users.delete': 'Delete user',
  'users.delete_confirm': 'Delete this user?',
  'users.email_already_taken': 'This email is already taken: {value}',

  'settings': 'Settings',
  'settings.json_message': 'Note: settings already provided in your <code>settings.json</code> file will be disabled.',
  'settings.edit': 'Edit Settings',
  'settings.edited': 'Settings edited (please reload).',
  'settings.title': 'Title',
  'settings.siteUrl': 'Site URL',
  'settings.description': 'Description',
  'settings.siteImage': 'Site Image',
  'settings.defaultEmail': 'Default Email',
  'settings.scoreUpdate': 'Score Update',
  'settings.postsPerPage': 'Posts Per Page',
  'settings.twitterAccount': 'Twitter Account',
  'settings.facebookPage': 'Facebook Page',
  'settings.locale': 'Locale',
  'settings.requireViewInvite': 'Require View Invite',
  'settings.requirePostInvite': 'Require Post Invite',
  'settings.scoreUpdateInterval': 'Score Update Interval',

  'app.loading': 'Loading…',
  'app.404': 'Sorry, we couldn\'t find what you were looking for.',
  'app.missing_document':  'Sorry, we couldn\'t find the document you were looking for.',
  'app.powered_by': 'Built with Vulcan.js',
  'app.or': 'Or',
  'app.noPermission': 'Sorry, you do not have the permission to do this at this time.',
  'app.operation_not_allowed': 'Sorry, you don\'t have the rights to perform the operation "{value}"',
  'app.document_not_found': 'Document not found (id: {value})',
  'app.disallowed_property_detected': 'Disallowed property detected: {value}',
  'app.something_bad_happened': 'Something bad happened...',
  'app.embedly_not_authorized': 'Invalid Embedly API key provided in the settings file. To find your key, log into https://app.embed.ly -> API',

  'cards.edit': 'Edit',
  'datatable.new': 'New',
  'datatable.edit': 'Edit',

  'admin': 'Admin',
  'notifications': 'Notifications',

  'errors.expectedType': 'Expected a field “{label}” of type {dataType}, got “{value}” instead.',
  'errors.required': 'Field “{label}” is required.',
  'errors.maxString': 'Field “{label}” is limited to {max} characters.',
  'errors.regEx': 'Field "{label}" is invalid.',
});
